import { render, staticRenderFns } from "./SchoolGeneralChart.vue?vue&type=template&id=4ff33d52&"
import script from "./SchoolGeneralChart.vue?vue&type=script&lang=js&"
export * from "./SchoolGeneralChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports